import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef, useContext } from 'react';
import { ScreenSizeContext } from '../Measured/ScreenSizeContext';
import { useMeasuredCookie } from '../Measured/useMeasuredCookie';
import { default as Grid } from './Grid';
const MeasuredGrid = (_param)=>{
    var { cookieType, defaultSize } = _param, gridProps = _object_without_properties(_param, [
        "cookieType",
        "defaultSize"
    ]);
    const { width: screenWidth } = useContext(ScreenSizeContext);
    const containerRef = useRef(null);
    const sentinelRef = useRef(null);
    const measuredContainer = useMeasuredCookie(cookieType, containerRef, {
        cookieDim: 'width',
        listenOnWindow: true,
        sentinelRef,
        defaultSize
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        ref: sentinelRef,
        style: {
            maxWidth: '100%'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ React.createElement(Grid, _object_spread_props(_object_spread({}, gridProps), {
        screenWidth: screenWidth,
        containerWidth: measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width
    }))));
};
MeasuredGrid.displayName = 'MeasuredGrid';
export default MeasuredGrid;
